// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.estrellaDammGlass',
  title: 'hardCoded.title.gastronomicEstrellaDammGlass',
  slug: titleToSlug('hardCoded.title.gastronomicEstrellaDammGlass'),
  catalog: {
    title: 'hardCoded.catalog.title.estrellaDammGlass',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#ffffff'
  }
}
